function getDigitalDataSubscriptionPromise(keyName, waitTime = 0) {
  let timeoutId = null;
  let resolver;
  let rejector;
  const thePromise = new Promise((res, rej) => {
    resolver = res;
    rejector = rej;
  });
  const featureFlagKey = `flag.${keyName}`;
  const splitTestKey = `test.${keyName}`;

  timeoutId = setTimeout(() => {
    subscriptionFeatureFlag.unsubscribe();
    subscriptionSplitTest.unsubscribe();
    rejector();
  }, waitTime);

  function keySubscriptionHandler(value) {
    if (typeof value !== 'undefined') {
      this.unsubscribe();
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }

      if (window.digitalData.get(featureFlagKey, false) || window.digitalData.get(splitTestKey, false)) {
        resolver(value);
      } else {
        resolver(false);
      }
    }
  }

  const subscriptionFeatureFlag = window.digitalData.subscribe(featureFlagKey, keySubscriptionHandler);
  const subscriptionSplitTest = window.digitalData.subscribe(splitTestKey, keySubscriptionHandler);

  return thePromise;
}

module.exports = { getDigitalDataSubscriptionPromise };
